module.exports = __webpack_public_path__ + "static/media/2tes gde.73e8793f.png";